import * as Yup from 'yup'
import * as service from '../../../services'
import { getInitialState } from '../../../utils/formikUpdate'

export const datasetFormik = async () => {
  const specieAll = await service.getSpecieAll()

  const ITEMS_PSEUDONYM_FORMIK = [
    { x: 12, name: 'pseudonymName_', initvalue: '', label: 'Nombre comun' },
    {
      x: 12,
      name: 'specie_',
      initvalue: '',
      label: 'Especie',
      options: specieAll,
    },
  ]

  const INITIAL_FORMIK_STATE = getInitialState(ITEMS_PSEUDONYM_FORMIK)

  const FORM_VALIDATION = Yup.object().shape({
    pseudonymName_: Yup.string().required('Requerido').max(30, 'Maximo 30 caracteres'),
    specie_: Yup.string().required('Requerido'),
  })

  return {
    INITIAL_FORMIK_STATE,
    ITEMS_PSEUDONYM_FORMIK,
    FORM_VALIDATION,
  }
}
